module.exports = __webpack_public_path__ + "static/twitter-new-0221fbe2a0852b3be16a635f59ac17bf.png";